import { name, version } from '../package.json';

export default {
    error: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, triggers the error state and shows the `errorText` for the input.',
        },
    },
    errorText: {
        type: Array,
        docs: {
            validation: '—',
            description: 'Sets the error text that appears when `error=true` for the input.',
            support: ['v-html'],
        },
    },
    hiddenLabel: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, visibly hides the input’s label.',
        },
    },
    label: {
        type: String,
        required: true,
        docs: {
            validation: '**Required**',
            description: 'Sets the label for the input.',
        },
    },
    microcopyAbove: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the microcopy above the input.',
            support: ['v-html'],
        },
    },
    microcopyBelow: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the microcopy below the input.',
            support: ['v-html'],
        },
    },
    onDark: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, changes component to on-dark styling.',
        },
    },
    optional: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, displays the `optionalText` on the input label.',
        },
    },
    optionalText: {
        type: String,
        default: '(Optional)',
        docs: {
            validation: '—',
            description: 'Sets the label text to describe an input as optional.',
        },
    },
    password: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'If `true`, renders the password variation of the input by setting `type="password"` and adding a button to hide and show the input value.',
        },
    },
    required: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, displays the required indicator (*) on the input label.',
        },
    },
    requiredText: {
        type: String,
        default: 'This field is required',
        docs: {
            validation: '—',
            description: 'Sets the `aria-label` text to describe an input as required.',
        },
    },
    rightAligned: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, right aligns the input’s text.',
        },
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `small`, `medium`, `large`, `touch`.',
            description: 'Sets the size of the input.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
